import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../Button';
import styles from './UpperJawToggle.module.css';

const propTypes = {
  /**
   * Selected toggle option
   */
  selectedOption: PropTypes.oneOf(['0', '1', '2'])
};

const defaultProps = {
  selectedOption: null,
  disabled: false,
  onClick: () => {}
};

function UpperJawToggle(props) {
  const { className: classNameProp, selectedOption, disabled, onClick } = props;
  const className = classNames(classNameProp, {
    [styles.isDefault]: selectedOption === '0',
    [styles.isOneSelected]: selectedOption === '1',
    [styles.isTwoSelected]: selectedOption === '2'
  });

  return (
    <Button
      className={className}
      disabled={disabled}
      onClick={onClick}
      data-test-id="upper-jaw-toggle"
      id="upper-jaw-toggle"
    >
      <div className={styles.after} />
    </Button>
  );
}

UpperJawToggle.propTypes = propTypes;
UpperJawToggle.defaultProps = defaultProps;

export default UpperJawToggle;
